import React from 'react';

import { css } from '@emotion/react';

import { gutterSizes } from '@gumtree/ui-library/src/base/theme';

const padding = css`
    margin-top: ${gutterSizes.base};
    margin-bottom: 0;
`;

export const SeoHeading = ({ children }: React.PropsWithChildren) => {
    return <h1 css={padding}>{children}</h1>;
};

export const H1 = ({ children }: React.PropsWithChildren) => {
    const styles = css`
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
    `;

    return <h1 css={[padding, styles]}>{children}</h1>;
};

export const H1Bold = ({ children }: React.PropsWithChildren) => {
    const styles = css`
        font-weight: 700;
    `;

    return <span css={[styles]}>{children}</span>;
};

export const H1Minor = ({ children }: React.PropsWithChildren) => {
    const styles = css`
        font-weight: 400;
    `;

    return <span css={[styles]}>{children}</span>;
};
